module.exports = __webpack_public_path__ + "images/6886a3714d1077d2badd426133e1e225.svg";